import { render, staticRenderFns } from "./admin_ssry.vue?vue&type=template&id=5a49d965&scoped=true"
import script from "./admin_ssry.vue?vue&type=script&lang=js"
export * from "./admin_ssry.vue?vue&type=script&lang=js"
import style0 from "./admin_ssry.vue?vue&type=style&index=0&id=5a49d965&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a49d965",
  null
  
)

export default component.exports